import { createSlice } from "@reduxjs/toolkit";
import { getRequestedDocByReqId } from "api/dashboardDetail";

const initialState = {
  requestedDocs: {},
  errorFetchingDocs: false,
  loadingDocs: false,
  is_view_mode: false,
};

export const requestedDocReducer = createSlice({
  name: "requestedDocReducer",
  initialState,
  reducers: {
    setRequestedDocs: (state, action) => {
      state.requestedDocs = action.payload.data;
    },
    clearRequestedDocs: (state, action) => {
      state.requestedDocs = {};
    },
    setIsViewMode: (state, action) => {
      state.is_view_mode = action.payload;
    },
    clearIsViewMode: (state, action) => {
      state.is_view_mode = false;
    },
  },
  extraReducers: {
    [getRequestedDocByReqId.pending]: (state, action) => {
      state.loadingDocs = true;
    },
    [getRequestedDocByReqId.rejected]: (state, action) => {
      state.errorFetchingDocs = true;
      state.loadingDocs = false;
    },
    [getRequestedDocByReqId.fulfilled]: (state, action) => {
      state.requestedDocs = action.payload.data;
    },
  },
});

export const {
  setRequestedDocs,
  clearRequestedDocs,
  setIsViewMode,
  clearIsViewMode,
} = requestedDocReducer.actions;

export default requestedDocReducer.reducer;
